// Librerías propias
import "../front/commons/global.js";

window.resultsPerPage = 20;

/**
 * Gets the current page from url.
 *
 * @return      {integer}  The current page
 */
window.getCurrentPage = function () {
    return parseInt(getCurrentParam('page', 1));
};

window.currentPage = getCurrentPage();

/**
 * Sets the current page from url.
 */
window.setCurrentPage = function () {
    setCurrentParameter('page', currentPage);
}

/**
 * Load de paginator
 *
 * @param   {integer}   count       The total elements to paginate
 * @param   {integer}   page        The currente page
 * @param   {integer}   limit       The limit per page
 */
window.fillPagination = function (count = 0, page = currentPage, limit = resultsPerPage) {
    // if (count == 0) {
    //     return;
    // }

    // Calculamos el total de páginas
    var totalPages = Math.ceil(count / limit);

    // Si sólo tengo una página no muestro la paginación
    if (totalPages <= 1) {
        $("#pagination").hide();
        return;
    }

    if (page < 1) {
        page = 1;
    }

    // Creamos el HTML para las páginas
    if (totalPages > 3) {
        var pagesHTML = `<li class="page-item">
                    <button class="page-link" onclick="loadPage(${page - 1});">
                        ${page - 1}
                    </button>
                </li>
                <li class="page-item active">
                    <span class="page-link">
                        ${page}
                    </span>
                </li>
                <li class="page-item">
                    <button class="page-link" onclick="loadPage(${page + 1});">
                        ${page + 1}
                    </button>
                </li>`;
        // Si al restar uno a la página actual es menor que uno no lo hacemos
        if (page - 1 < 1) {
            pagesHTML = `<li class="page-item active">
                            <span class="page-link">
                                ${page}
                            </span>
                        </li>
                        <li class="page-item">
                            <button class="page-link" onclick="loadPage(${page + 1});">
                                ${page + 1}
                            </button>
                        </li>
                        <li class="page-item">
                            <button class="page-link" onclick="loadPage(${page + 2});">
                                ${page + 2}
                            </button>
                        </li>`;
        }

        // Si al sumar uno a la página actual supera el total de páginas no lo hacemos
        if (page + 1 > totalPages) {
            pagesHTML = `<li class="page-item">
                            <button class="page-link" onclick="loadPage(${page - 2});">
                                ${page - 2}
                            </button>
                        </li>
                        <li class="page-item">
                            <button class="page-link" onclick="loadPage(${page - 1});">
                                ${page - 1}
                            </button>
                        </li>
                        <li class="page-item active">
                            <span class="page-link">
                                ${page}
                            </span>
                        </li>`;
        }
    } else {
        pagesHTML = "";
        for (var i = 1; i <= totalPages; i++) {
            pagesHTML += `<li class="page-item" ${i == page ? "active" : ""}>
                            ${i == page ?
                                `<span class="page-link">` :
                                `<button class="page-link" onclick="loadPage(${i});">`
                            }
                                ${i}
                            ${i == page ?
                                `</span>` :
                                `</button>`
                            }
                        </li>`;
        }
    }

    var newHTML = `<li id="firstPage" class="page-item ${page == 1 ? "disabled" : ""}">
                    <button class="page-link" onclick="loadPage(${1});"><i class="fas fa-angle-double-left"></i></button>
                </li>
                <li id="previousPage" class="page-item ${page == 1 ? "disabled" : ""}">
                    <button class="page-link" onclick="loadPage(${page - 1});">${trans("pagination.previous")}</button>
                </li>
                ${pagesHTML}
                <li id="nextPage" class="page-item ${page == totalPages ? "disabled" : ""}">
                    <button class="page-link" onclick="loadPage(${page + 1});">${trans("pagination.next")}</button>
                </li>
                <li id="lastPage" class="page-item ${page == totalPages ? "disabled" : ""}">
                    <button class="page-link" onclick="loadPage(${totalPages});"><i class="fas fa-angle-double-right"></i></button>
                </li>`;
    // Si no existe el elemento de paginación lo pintamos, si existe machacamos su contenido
    $("#pagination").show();
    $("#pagination ul").html(newHTML);
};
